import '~/pages/projects/show/index';
import initGeoInfoModal from '../../../init_geo_info_modal';

document.addEventListener('DOMContentLoaded', initGeoInfoModal);
